import { Item } from "@elements/barsChart/BarsChart";
import { CropInfo } from "../../../../store/reducers/dashboard/crops/types";
import React, { useMemo } from "react";
import { Tooltip } from "@infobis/ui-styles-utils";
import { CircleLabel } from "../../works/detalization/dynamics";
import { formatNumber2d } from "@utils/format/number";
import st from './styles.module.scss';
import BaseChartTooltip
    from "../../../../components/modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/BaseChartTooltip";
import {
    RowWithAreaFormatter
} from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/rowFormatters/RowFormatters";
import BarsChartWithLegend from "@elements/barsChartWithLegend/BarsChartWithLegend";

type ChartItemAdditionally = { children: Item<ChartItemAdditionally>[], dimension: string }

type CropsChartProps = {
    cultivatedArea: CropInfo[]
    totalGeoZoneHa: number
}

const CropsChart = (props: CropsChartProps) => {
    const {
        cultivatedArea,
        totalGeoZoneHa
    } = props;

    const convertCropToChartItem = (value: CropInfo): Item<ChartItemAdditionally> => {
        return {
            id: value.cropId,
            color: value.color,
            value: value.area.value,
            name: value.crops,
            children: value.children.map(convertCropToChartItem),
            dimension: value.area.dimension
        }
    }

    const getLegendRowValues = (row: Item<ChartItemAdditionally>) => {
        return [
            <Tooltip.Flex tooltipProps={{ bodyClassName: st['tooltip__body'] }}
                          text={<CircleLabel align={'start'} color={row.color} name={row.name} ellipsis/>} />,
            <Tooltip.Flex tooltipProps={{ bodyClassName: st['tooltip__body'] }}
                          text={
                              <span style={{ textAlign: 'end' }}>
                                  <span className={st["chart__legend__value"]}>{formatNumber2d(row.value)} </span>
                                  <span className={st["chart__legend__percent"]}>({formatNumber2d(row.value / totalGeoZoneHa * 100)}%)</span>
                              </span>
                          }
            />,
        ]
    }

    const getTooltipText = (point: Item<ChartItemAdditionally>) => {
        const children = point.children.length === 0 ? [ point ] : point.children

        return (
            <BaseChartTooltip
                elements={children.map(child => ({
                    id: child.id,
                    color: child.color,
                    name: child.name,
                    area: child.value,
                    dimension: child.dimension
                }))}
                cellsInRow={2}
                RowFormatter={RowWithAreaFormatter}
            />
        )
    }

    const itemsToRender = useMemo(() => {
        const itemsWithoutUnknown = cultivatedArea
            .filter(item => item.cropId !== 'unknown')
            .sort((a, b) => b.area.value - a.area.value)
        const unknownItem = cultivatedArea.find(item => item.cropId === 'unknown')

        const orderedItems = unknownItem ? [...itemsWithoutUnknown, unknownItem] : itemsWithoutUnknown

        return orderedItems.map(convertCropToChartItem)
    }, [cultivatedArea])

    return (
        <BarsChartWithLegend items={itemsToRender}
                             legendProps={{
                                 height: 230,
                                 headersR: [<div>Культура</div>, <div style={{textAlign: 'end'}}>Площадь, Га</div>]
                             }}
                             suppressTooltipStyles
                             getLegendRowValues={getLegendRowValues}
                             getTooltipText={getTooltipText}
                             tooltipProps={{ trigger: 'hover' }}
                             disabledByDefaultElements={['unknown']} />
    )
}

export default CropsChart;